/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Open_SettingInputs */

const en_us2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open in the profile`)
};

const pt_br2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no perfil`)
};

const es_419_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir en el perfil`)
};

const pt_pt2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir no perfil`)
};

const fr_fr2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir dans le profil`)
};

const de_de2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Im Profil öffnen`)
};

const it_it2_search_open_setting = /** @type {(inputs: Search_Open_SettingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri nel profilo`)
};

/**
* | output |
* | --- |
* | "Open in the profile" |
*
* @param {Search_Open_SettingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_open_setting = /** @type {((inputs?: Search_Open_SettingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Open_SettingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_open_setting(inputs)
	if (locale === "es-419") return es_419_search_open_setting(inputs)
	if (locale === "pt-PT") return pt_pt2_search_open_setting(inputs)
	if (locale === "fr-FR") return fr_fr2_search_open_setting(inputs)
	if (locale === "de-DE") return de_de2_search_open_setting(inputs)
	if (locale === "it-IT") return it_it2_search_open_setting(inputs)
	return en_us2_search_open_setting(inputs)
});
export { search_open_setting as "search.open_setting" }